import { AccessoriesPageData } from 'src/modules/accessories/AccessoriesPageMapping.ts';

export const excludeIncompatible = (labels: string[]) => (
    item: AccessoriesPageData['vssAccessories']['valveAccessories'][0]['item'],
) => {
    const incompatibleProducts = item.incompatibleProducts?.raw || [];
    return incompatibleProducts.filter((label) => labels.includes(label)).length === 0;
};
